export default {
  MuiAccordion: {
    root: {
      '&:before': {
        content: 'none',
      },
      '&$expanded': {
        margin: 0,
      },
      boxShadow: 'none',
    },
  },
};
